export default __webpack_public_path__ + "static/media/testimonial-3.bdd95893.png";